module.exports = __webpack_public_path__ + "img/particle_motion_00088.737533a6.png";